module.exports = __webpack_public_path__ + "static/media/program-learning-banner.e23a44db.png";